(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  /* Lubeko Black Month copy button */
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-black-month-code]');
    if (!button) return;
    const code = button.dataset.blackMonthCode;
    if (!navigator.clipboard || !code) return;
    navigator.clipboard.writeText(code).then(function () {
      const originalLabel = button.innerHTML;
      button.textContent = 'Copied!';
      window.setTimeout(function () { button.innerHTML = originalLabel; }, 1400);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lubeko-live-footer"] && !Shopify.designMode) return;
  try {
    
  function setLubekoFooterDetails() {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('.lk-live-footer__details').forEach((detail) => {
      if (mobile) detail.removeAttribute('open');
      else detail.setAttribute('open', '');
    });
  }
  setLubekoFooterDetails();
  window.addEventListener('resize', setLubekoFooterDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
